import { lazy } from 'react';

import Loadable from 'components/Loadable';

const Idemia = Loadable(lazy( () => import('modules/Idemia')));
const Finish = Loadable(lazy( () => import('modules/Idemia/screens/FinishIdemia')))

export const route = [{
    path: 'idemia/results',
    element: <Finish />
  }, {
    path: 'idemia/:account/:data',
    element: <Idemia/>,
  },

];

/// idemia/:account/:data
